import UploadPromotionCodeField from './UploadPromotionCodeField'
import withUploadPromotionCodeField from './withUploadPromotionCodeField'

const ConnectedUploadPromotionCodeField = withUploadPromotionCodeField(
  UploadPromotionCodeField
)

export { ConnectedUploadPromotionCodeField as UploadPromotionCodeField }
